const riot = require('riot');

riot.tag2('page-firstcome_events-single', '<div class="s-full min-height-100per py24" show="{event}"> <div class="f fclm container-538 s-full px16"><img class="block w-full object-fit-contain mb15" if="{event?.firstcome_rule.limit_reached_image_url}" ref="general_image" riot-src="{event?.firstcome_rule.limit_reached_image_url}" alt="メイン画像" onload="{_.noop}"> <div class="text-center ts-ps text-gray_80" if="{event?.firstcome_rule.description}">{event?.firstcome_rule.description}</div> <module-footer class="pt16 mta" event="{event.campaign}" is-email-terms-hidden="{true}"></module-footer> </div> </div>', 'page-firstcome_events-single,[data-is="page-firstcome_events-single"]{display:block}', '', function(opts) {

    this.event = undefined;

    this.preload = async ({req, res}) => {
      const onetime_hash = req.query.hash;

      if (!onetime_hash) throw { status: 404 };
      try {

        const event = await app.api.child('firstcome_events:getByOnetimeHash').get({
          onetime_hash,
        });

        if (event.distribution_event_onetime_hash) {
          res.redirect(301, `/gift/?hash=${event.distribution_event_onetime_hash}`);
          return ;
        }

        return {
          event,
        };
      }
      catch(e) {
        if (e.status === 404) {
          e.customMessage = '有効期限がきれているか、受取済みの可能性があります。';
        }
        throw e;
      }
    };

    this.head = () => {
      return {
        title: '受け取り画面 | Repro Incentive',
      };
    };
});